export default __webpack_public_path__ + "static/media/MishLoginBG.d737975a.jpg";